import { DateConverter } from '@shared/entities/converters/date-converter';
import { JsonObject, JsonProperty } from 'json2typescript';
import { Entity } from './entity';

@JsonObject('Contract')
export class Contract extends Entity {
  @JsonProperty('name', String)
  public name?: string = undefined;
  @JsonProperty('createdDate', DateConverter)
  public createdDate?: Date = undefined;
  @JsonProperty('assetId', String)
  public assetId?: string = undefined;
  @JsonProperty('assetInstallDate', DateConverter)
  public assetInstallDate?: Date = undefined;
  @JsonProperty('startDate', DateConverter)
  public startDate?: Date = undefined;
  @JsonProperty('endDate', DateConverter)
  public endDate?: Date = undefined;
  @JsonProperty('contractName', String)
  public contractName?: string = undefined;
  @JsonProperty('category', String)
  public category?: string = undefined;
  @JsonProperty('interventionsPerYear', Number)
  public interventionsPerYear?: number = undefined;
  @JsonProperty('installDate', DateConverter)
  public installDate?: Date = undefined;
  @JsonProperty('serialNumber', String)
  public serialNumber?: string = undefined;
  @JsonProperty('state', String)
  public state?: 'VALIDO' | 'IN SCADENZA' | 'SCADUTO' | 'Non disponibile' = undefined;
}
